import { Modal } from '@bp/ui-components';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { lowercaseFirstLetter } from 'utils/stringHelper';
import { useIsDesktop } from '../../../hooks/useIsDesktop';
import { useStackHandler } from '../../../hooks/useStackHandler';
import { AbsenceForm } from '../forms/AbsenceForm';
import { AbsenceContext, MyAbsenceContext } from '../types/absenceTypes';

type AbsenceModalProps = {
  isOpen: boolean;
  context: AbsenceContext | MyAbsenceContext;
  selectedAbsenceUuid: string | null;
  onClose: () => void;
};

export const AbsenceModal = ({ isOpen, context, selectedAbsenceUuid, onClose }: AbsenceModalProps) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);

  const isDesktop = useIsDesktop();
  const stackHandler = useStackHandler();

  useEffect(() => {
    if (isOpen && !isDesktop) {
      stackHandler.push({
        id: `absence-modal-${selectedAbsenceUuid ?? 'new'}-${context}`,
        title: selectedAbsenceUuid
          ? t('common.editType', {
              type: `${t('absences.title', { count: 1 })} ${context !== 'admin' && context !== 'teacher' ? lowercaseFirstLetter(context === 'child' ? t('absences.forChild') : t('common.forMe')) : ''}`,
            })
          : t('common.addType', {
              type: `${t('absences.title', { count: 1 })} ${context !== 'admin' && context !== 'teacher' ? lowercaseFirstLetter(context === 'child' ? t('absences.forChild') : t('common.forMe')) : ''}`,
            }),
        group: 'absences',
        onClose: () => {
          onClose();
        },
        component: (
          <AbsenceForm
            context={context}
            selectedAbsenceUuid={selectedAbsenceUuid}
            onLoad={setLoading}
            onClose={() => {
              stackHandler.closeById(`absence-modal-${selectedAbsenceUuid ?? 'new'}-${context}`);
            }}
          />
        ),
      });
    }
  }, [isDesktop, context, isOpen, onClose, selectedAbsenceUuid, stackHandler, t]);

  return !isDesktop ? (
    <></>
  ) : (
    <Modal
      title={
        selectedAbsenceUuid
          ? t('common.editType', {
              type: `${t('absences.title', { count: 1 })} ${context !== 'admin' && context !== 'teacher' ? lowercaseFirstLetter(context === 'child' ? t('absences.forChild') : t('common.forMe')) : ''}`,
            })
          : t('common.addType', {
              type: `${t('absences.title', { count: 1 })} ${context !== 'admin' && context !== 'teacher' ? lowercaseFirstLetter(context === 'child' ? t('absences.forChild') : t('common.forMe')) : ''}`,
            })
      }
      loading={loading}
      isOpen={isOpen}
      onRequestClose={onClose}
    >
      <AbsenceForm context={context} selectedAbsenceUuid={selectedAbsenceUuid} onLoad={setLoading} onClose={onClose} />
    </Modal>
  );
};
